import { all, call, put, takeEvery } from "redux-saga/effects";
import {
  setScreenWidthSuccess,
  setScreenWidthFailure,
} from "../../Action/dashboard/setScreenWidthAction.js";
import { SET_SCREEN_WIDTH } from "../../Action/actionTypes";

function* handleScreenWidth(action) {
  try {
    const width = action.payload?.payload;

    if (typeof width === "number") {
      yield put(setScreenWidthSuccess(width));
      if (action?.payload?.callback) {
        yield call(action.payload.callback, width);
      }
    } else {
      yield put(setScreenWidthFailure());
    }
  } catch (error) {
    yield put(setScreenWidthFailure());
  }
}

export function* watchSetScreenWidth() {
  yield takeEvery(SET_SCREEN_WIDTH, handleScreenWidth);
}

export default function* rootSaga() {
  yield all([watchSetScreenWidth()]);
}
